import { lanzamientoimg } from "./images";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

export const LanzamientoBanner = () => {
  return (
    <Container id="123">
      <div>
        <img src={lanzamientoimg.url} />
        <a
          href="https://panettonefleischmann.ewebinar.com/webinar/el-panettone-si-es-negocio-22246"
          target="blank"
          style={{ position: "absolute", top: "65%", left: "10%" }}
        >
          <Button
            // color="secondary"
            // sx={{
            //   zIndex: 100,
            //   backgroundColor: "#124c97",
            //   color: "#fff",
            //   fontSize: "1rem",
            //   "&:hover": {
            //     backgroundColor: "#b86e3a",
            //   },
            //   "@media (max-width: 768px)": {
            //     fontSize: ".6rem !important",
            //   },
            // }}
            variant="contained"
          >
            INGRESA AQUÍ
          </Button>
        </a>
      </div>
    </Container>
  );
};

const Container = styled.div`
  margin-top: 100px;
  @media (max-width: 768px) {
    margin-top: 70px;
  }

  > div {
    max-height: 650px;
    width: fit-content;
    margin-inline: auto;
    position: relative;
    img {
      width: 100%;
      height: auto;
      max-height: 650px;
      object-fit: contain;
    }
  }
`;
